import { render, staticRenderFns } from "./DealerAppBar.vue?vue&type=template&id=2ce971e9&lang=pug&"
import script from "./DealerAppBar.vue?vue&type=script&lang=js&"
export * from "./DealerAppBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports